import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import RadioButton from "./RadioButton"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function RadioField({
  className,
  error,
  id,
  name,
  options,
  schema,
  label,
  labelId,
  selectedOption,
  onChange,
  onBlur = _.noop,
  ...otherProps
}) {
  const handleChange = key => {
    // we need to dispatch onBlur to fix issue in iphone/ipad
    onChange(name, key)
    onBlur(name, key)
  }

  return (
    <div
      className={classNames("oj-radio-field", className)}
      role="radiogroup"
      aria-labelledby={labelId}
    >
      <Field error={error}>
        <Field.Label id={labelId} label={label} required={schema.required} />
        <Field.Input id={id} error={error} {...schema}>
          <div className="options">
            {_.map(options, ({ label: optionLabel, value, ...rest }) => (
              <RadioButton
                key={value}
                {...otherProps}
                id={`${id}-${value}`}
                name={id}
                label={optionLabel}
                checked={value === selectedOption}
                className={_.kebabCase(value)}
                {...rest}
                onBlur={() => onBlur(name, value)}
                onChange={() => handleChange(value)}
              />
            ))}
          </div>
        </Field.Input>
      </Field>
    </div>
  )
}

RadioField.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  error: PropTypes.shape(errorPropTypes),
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  labelId: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  schema: PropTypes.shape(fieldSchemaPropTypes).isRequired,
  selectedOption: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func
}

export default RadioField
